import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";

// Register ChartJS components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function MedalTallyGraph() {
  const [medalData, setMedalData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const apiUrl = "/api/home/overall-mt";

  useEffect(() => {
    fetch(apiUrl)
      .then((r) => {
        if (!r.ok) throw new Error("Failed to fetch medal data");
        return r.json();
      })
      .then((data) => {
        setMedalData(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message || "Unknown error");
        setLoading(false);
      });
  }, []);

  if (loading)
    return (
      <section id="medal-tally" className="graph-section">
        <div className="container">
          <div className="row">
            <div className="wow fadeInUp col-md-offset-1 col-md-10 col-sm-offset-1 col-sm-10 text-center" data-wow-delay="0.9s">
              <div className="section-title">
                <h2>Medal Tally</h2>
                <p>Loading medal tally chart...</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  if (error)
    return (
      <section id="medal-tally" className="graph-section">
        <div className="container">
          <div className="row">
            <div className="wow fadeInUp col-md-offset-1 col-md-10 col-sm-offset-1 col-sm-10 text-center" data-wow-delay="0.9s">
              <div className="section-title">
                <h2>Medal Tally</h2>
                <p style={{ color: "red" }}>Error: {error}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );

  // Prepare data for Chart.js
  const labels = medalData.map((row) => row.team);
  const goldData = medalData.map((row) => row.gold);
  const silverData = medalData.map((row) => row.silver);
  const bronzeData = medalData.map((row) => row.bronze);

  const data = {
    labels,
    datasets: [
      {
        label: "Gold",
        data: goldData,
        backgroundColor: "rgba(255, 215, 0, 0.7)",
        borderColor: "rgba(255, 215, 0, 1)",
        borderWidth: 1,
      },
      {
        label: "Silver",
        data: silverData,
        backgroundColor: "rgba(192,192,192, 0.7)",
        borderColor: "rgba(192,192,192, 1)",
        borderWidth: 1,
      },
      {
        label: "Bronze",
        data: bronzeData,
        backgroundColor: "rgba(205, 127, 50, 0.7)",
        borderColor: "rgba(205, 127, 50, 1)",
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false, // VERY IMPORTANT
    plugins: {
      legend: { position: "top" },
      title: { display: false },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Number of Medals"
        },
      },
      x: {
        title: {
          display: true,
          text: "Teams"
        },
      },
    },
  };

  return (
    <section id="medal-tally" className="graph-section">
      <div className="container">
        <div className="row">
          <div className="wow fadeInUp col-md-offset-1 col-md-10 col-sm-offset-1 col-sm-10 text-center" data-wow-delay="0.9s">
            <div className="section-title">
              <h2>Medal Tally</h2>
              <p>Check out the performance of different teams!</p>
            </div>
            {/* Chart container for size control */}
            <div style={{ width: "100%", height: "400px" }}>
              <Bar data={data} options={options} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
